import SuccessIcon from './SuccessIcon'
import CareerPathIcon from './CareerPath'
import HotIcon from './Hot'
import UrgentIcon from './Urgent'

const Alert = {
    SuccessIcon,
    CareerPathIcon,
    HotIcon,
    UrgentIcon
}

export default Alert
